import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/auth",
  component: RouteComponent,
  children: [
    {
      path: "login",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "auth.login",
          component: () =>
            import(
              /* webpackChunkName: "auth-login" */ "@/views/login/LoginView.vue"
            ),
          props: (route) => ({ module: route.query.module }),
          meta: {
            title: "Login",
            header: { show: false },
            navbar: { show: false },
            footer: { show: false },
            container: {
              fillHeight: true,
              fluid: true,
            },
          },
        },
        {
          path: "enterprise",
          name: "auth.login.enterprise",
          redirect: { name: "auth.login" },
        },
        {
          path: "firm",
          name: "auth.login.firm",
          redirect: { name: "auth.login" },
        },
      ],
    },
    {
      path: "registration",
      component: RouteComponent,
      children: [
        {
          path: "",
          redirect: { name: "auth.login" },
        },
        {
          path: "confirm",
          name: "auth.registration.confirm",
          component: () =>
            import(
              /* webpackChunkName: "auth-registration-confirm" */ "@/views/ConfirmRegistration.vue"
            ),
          props: (route) => ({
            token: route.query.token,
            module: route.query.module,
          }),
          meta: {
            title: "Conferma Registrazione",
            header: { show: false },
            navbar: { show: false },
            footer: { show: false },
            container: {
              fillHeight: true,
              fluid: true,
            },
          },
        },
      ],
    },
    {
      path: "password",
      component: RouteComponent,
      children: [
        {
          path: "request",
          name: "auth.password.request",
          component: () =>
            import(
              /* webpackChunkName: "auth-password" */ "@/views/password/PasswordRequestView.vue"
            ),
          props: (route) => ({ module: route.query.module }),
          meta: {
            title: "Password Dimenticata",
            header: { show: false },
            navbar: { show: false },
            footer: { show: false },
            container: {
              fillHeight: true,
              fluid: true,
            },
          },
        },
        {
          path: "request/validate",
          name: "auth.password.validate",
          component: () =>
            import(
              /* webpackChunkName: "auth-password" */ "@/views/password/PasswordRequestValidateView.vue"
            ),
          props: (route) => ({
            token: route.query.token,
            module: route.query.module,
          }),
          meta: {
            title: "Password Dimenticata - Validazione",
            header: { show: false },
            navbar: { show: false },
            footer: { show: false },
            container: {
              fillHeight: true,
              fluid: true,
            },
          },
        },
      ],
    },
  ],
};
